<script>
const images = import.meta.glob('../assets/img/*',{ eager: true })

export default {
  methods: {
    imagePath(path) {
      const url = images[`../assets/img/${path}`]

      return url ? url.default : null
    }
  }
}
</script>
